import axios from "axios";

// ============================================================
// YouTube Proxy – calls the backend API.
// All video data is stored in the DB, populated via WebSub webhook.
// Zero YouTube API quota used for frontend requests.
// ============================================================

//const API_BASE = "https://kuvendiapi.azurewebsites.net/api/YouTube";
const API_BASE = "https://kuvendiapi.azurewebsites.net/api/YouTube";

/**
 * Fetches videos from the backend DB.
 * Zero YouTube API quota — all data comes from the database,
 * populated by the YouTube WebSub webhook.
 *
 * @param {Object} options
 * @param {string} [options.pageToken] - Page number for pagination
 * @param {number} [options.maxResults=6] - Number of results per page
 * @param {string} [options.query] - Optional search query to filter videos
 * @returns {Promise<{ videos: Array, nextPageToken: string|null }>}
 */
export async function fetchChannelVideos({
  pageToken,
  maxResults = 6,
  query,
} = {}) {
  // If there's a text query, use the search endpoint
  if (query) {
    const params = { query, maxResults };
    if (pageToken) params.pageToken = pageToken;

    const res = await axios.get(`${API_BASE}/search`, { params });
    return res.data;
  }

  // Otherwise use the videos endpoint (reads from DB)
  const params = { maxResults };
  if (pageToken) params.page = pageToken;

  const res = await axios.get(`${API_BASE}/videos`, { params });
  return res.data;
}

/**
 * Checks whether the YouTube channel is currently live-streaming.
 * Reads from the DB — zero quota.
 * @returns {Promise<{ isLive: boolean, liveVideos: Array }>}
 */
export async function checkChannelLive() {
  const res = await axios.get(`${API_BASE}/live`);
  return res.data;
}

/**
 * Builds a YouTube embed URL for a given video ID.
 * Uses youtube-nocookie.com (privacy-enhanced mode) to avoid
 * ad-blocker interference that causes Error 153.
 * @param {string} videoId
 * @returns {string}
 */
export function getYouTubeEmbedUrl(videoId) {
  const origin = window.location.origin;
  return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&origin=${encodeURIComponent(
    origin
  )}`;
}
